import type { QueryHookOptions } from '@apollo/client';
import {
  type ListOrgHierarchyRelationsQuery,
  type ListOrgHierarchyRelationsQueryHookResult,
  type ListOrgHierarchyRelationsQueryVariables,
  useListOrgHierarchyRelationsQuery,
} from '@/common/graphql';

type Props = Omit<
  QueryHookOptions<ListOrgHierarchyRelationsQuery, ListOrgHierarchyRelationsQueryVariables>,
  'variables'
> & {
  variables?: Partial<ListOrgHierarchyRelationsQueryVariables>;
};

type UseOrgHierarchyRelationsReturn = Omit<ListOrgHierarchyRelationsQueryHookResult, 'data'> & {
  data: ListOrgHierarchyRelationsQuery['listOrgHierarchyRelations']['items'];
};

export const useOrgHierarchyRelations = ({ variables, ...options }: Props): UseOrgHierarchyRelationsReturn => {
  const { data, ...rest } = useListOrgHierarchyRelationsQuery({
    variables: {
      countryIds: variables?.countryIds || null,
      companyId: variables?.companyId || null,
      businessUnitId: variables?.businessUnitId || null,
      departmentId: variables?.departmentId || null,
      keyword: variables?.keyword || null,
    },
    ...options,
  });

  return {
    ...rest,
    data: data?.listOrgHierarchyRelations?.items ?? [],
  };
};
